<template>
	<div class="container pb_0">
		<div class="main">
			<p class="text_t type1">
				{{ $t('rtr_personal-request-commission.text1') }}
			</p>
			<p class="text_n">{{ $t('rtr_personal-request-commission.text2') }}</p>
			<div class="button_area">
				<button class="button_bg_red mr_10" @click="toLogin">
					{{ $t('button.signup') }}
				</button>
				<button class="button_bg_black" @click="notYet">
					{{ $t('button.down') }}
				</button>
			</div>
		</div>
		<div class="bottom_area_wrap">
			<div class="bottom_area">
				<div class="bg_box mb_16">
					<div class="bg_text_area left">
						<p class="text_t fc_white">
							{{ $t('rtr_personal-request-commission.text3') }}<br />
							{{ $t('rtr_personal-request-commission.text4') }}
						</p>
						<p class="text_n fc_white">
							{{ $t('rtr_personal-request-commission.text5') }}<br />{{
								$t('rtr_personal-request-commission.text6')
							}}
						</p>
					</div>
				</div>

				<div class="bg_box">
					<div class="bg_text_area left tac">
						<p class="text_t mb_30">
							{{ $t('rtr_personal-request-commission.text7') }}<br />
							{{ $t('rtr_personal-request-commission.text8') }}
						</p>
						<p class="text_n">
							{{ $t('rtr_personal-request-commission.text9') }}<br />
							{{ $t('rtr_personal-request-commission.text10') }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Commission',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
